import axios from 'axios';

const BASE_URL = process.env.REACT_APP_MESSAGES_URL;

const getUserId = () => {
  const info = JSON.parse(localStorage.getItem('userInfo') || '{}');
  return info.UserId;
};

export const messageService = {
  getInboxMessages: (userId, params = {}) => {
    return axios.get(`${BASE_URL}/messages/inbox/6948`);
  },

  getSentMessages: (userId, limit) => {
    const params = limit ? { limit } : {};
    return axios.get(`${BASE_URL}/messages/sent/6948`);
  },

  sendMessage: (message) => {
    return axios.post(`${BASE_URL}/messages`, message);
  },

  markAsRead: (messageId) => {
    return axios.put(`${BASE_URL}/messages/${messageId}/read`, {}, { params: { userId: 6948 } });
  },

  getConversation: (userId, otherUserId, limit) => {
    const params = limit ? { limit } : {};
    return axios.get(`${BASE_URL}/messages/conversation/6948/${otherUserId}`);
  },

  getStats: (userId) => {
    return axios.get(`${BASE_URL}/messages/stats/6948`);
  },

  getContacts: (userId) => {
    return axios.get(`${BASE_URL}/contacts/office`);
  },

  getContactById: (contactId) => {
    return axios.get(`${BASE_URL}/contacts/detail/${contactId}`);
  },
};

export default messageService;
